module.exports = __webpack_public_path__ + "img/money-bill.1c72f658.svg";